import React from 'react'
import colors from '@sportninja/common/constants/appColors'

/**
 * Hockey Jersey SVG Pattern (Web)
 * @param {string} color - Jersey color hex
 * @param {number} width - SVG width
 * @param {number} height - SVG height
 */
const HockeyJersey = ({
  color = colors.PRIMARY,
  width = 172,
  height = 121,
}) => {
  return (
    <svg width={width} height={height} viewBox='0 0 172 121' fill='none'>
      {/* Main jersey body with dynamic color */}
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M35.4521 73V113C35.4521 114.105 36.3476 115 37.4522 115H85.4521H86.4521H134.452C135.557 115 136.452 114.105 136.452 113V73L151.242 105.442C151.651 106.339 152.652 106.804 153.601 106.538L162.507 104.045C163.578 103.745 164.199 102.629 163.889 101.561L142.952 29.5C142.952 29.5 141.452 20.5 134.452 13.5C127.452 6.5 113.452 6 113.452 6H86.4521H85.4521H58.4521C58.4521 6 44.4521 6.5 37.4521 13.5C30.4521 20.5 28.9521 29.5 28.9521 29.5L8.01562 101.561C7.70532 102.629 8.32594 103.745 9.39694 104.045L18.3033 106.538C19.2524 106.804 20.2536 106.339 20.6624 105.442L35.4521 73Z'
        fill={color}
      />

      {/* Jersey outline/border */}
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M33.4522 121C31.243 121 29.4522 119.209 29.4522 117V100.626L24.7013 111.047C23.8837 112.84 21.8813 113.771 19.9832 113.239L3.88958 108.733C1.74759 108.133 0.506335 105.901 1.12694 103.765L23.11 28.1029C23.1242 28.0313 23.1405 27.9514 23.159 27.8635C23.2323 27.5151 23.3405 27.0405 23.4922 26.4621C23.7948 25.3084 24.2752 23.7244 25.0063 21.8967C26.4559 18.2726 28.968 13.4989 33.2095 9.25736C37.9255 4.54134 44.5352 2.35128 49.2402 1.27585C51.7037 0.71277 53.9077 0.398367 55.4999 0.223402C56.2998 0.135498 56.9554 0.0816989 57.4241 0.0493741C57.6587 0.0331941 57.8473 0.0223422 57.9845 0.0152721C58.0531 0.0117354 58.109 0.00914145 58.1515 0.00729799L58.205 0.00507021L58.2241 0.00433302L58.235 0.00393009C58.235 0.00393009 58.238 0.0038228 58.4522 6C58.4522 6 44.4522 6.5 37.4522 13.5C30.4522 20.5 28.9522 29.5 28.9522 29.5L8.01563 101.561C7.70533 102.629 8.32595 103.745 9.39695 104.045L18.3033 106.538C19.2524 106.804 20.2536 106.339 20.6624 105.442L35.4522 73V113C35.4522 114.105 36.3476 115 37.4522 115H134.452C135.557 115 136.452 114.105 136.452 113V73L151.242 105.442C151.651 106.339 152.652 106.804 153.601 106.538L162.507 104.045C163.578 103.745 164.199 102.629 163.889 101.561L142.952 29.5C142.952 29.5 141.452 20.5 134.452 13.5C127.452 6.5 113.452 6 113.452 6C113.666 0.0038228 113.669 0.00393009 113.669 0.00393009L113.68 0.00433302L113.699 0.00507021L113.753 0.00729799C113.795 0.00914145 113.851 0.0117354 113.92 0.0152721C114.057 0.0223422 114.246 0.0331941 114.48 0.0493741C114.949 0.0816989 115.604 0.135498 116.404 0.223402C117.997 0.398367 120.201 0.71277 122.664 1.27585C127.369 2.35128 133.979 4.54134 138.695 9.25736C142.936 13.4989 145.448 18.2726 146.898 21.8967C147.629 23.7244 148.109 25.3084 148.412 26.4621C148.564 27.0405 148.672 27.5151 148.745 27.8635C148.764 27.9514 148.78 28.0313 148.794 28.103L170.777 103.765C171.398 105.901 170.157 108.133 168.015 108.733L151.921 113.239C150.023 113.771 148.021 112.84 147.203 111.047L142.452 100.626V117C142.452 119.209 140.661 121 138.452 121H33.4522ZM113.452 6H58.4522L58.238 0.0038228L58.345 0H113.559L113.666 0.0038228L113.452 6Z'
        fill='#060A10'
      />

      {/* Left sleeve shadow */}
      <path
        opacity='0.5'
        d='M35.4521 68V57L22.4521 51.5L19.4521 61.5L35.4521 68Z'
        fill='black'
      />

      {/* Left sleeve detail */}
      <path
        opacity='0.5'
        d='M16.4521 72.5L32.9521 78.5L28.9521 87.5L13.9521 81L16.4521 72.5Z'
        fill='black'
      />

      {/* Neck/collar detail */}
      <path
        opacity='0.5'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M58.4524 6H85.4519H86.4524H113.452C113.452 6 127.452 6.5 134.452 13.5C141.452 20.5 142.952 29.5 142.952 29.5L143.076 29.9259C138.973 31.0036 131.866 31.3379 127.952 26C123.552 20 117.452 19.1667 114.952 19.5H86.4524H85.4519H56.9524C54.4524 19.1667 48.3524 20 43.9524 26C40.0379 31.3379 32.9313 31.0036 28.8286 29.9259L28.9524 29.5C28.9524 29.5 30.4524 20.5 37.4524 13.5C44.4524 6.5 58.4524 6 58.4524 6Z'
        fill='black'
      />

      {/* Right sleeve shadow */}
      <path
        opacity='0.5'
        d='M136.452 68V57L149.452 51.5L152.452 61.5L136.452 68Z'
        fill='black'
      />

      {/* Right sleeve detail */}
      <path
        opacity='0.5'
        d='M155.452 72.5L138.952 78.5L142.952 87.5L157.952 81L155.452 72.5Z'
        fill='black'
      />

      {/* Bottom stripe */}
      <rect
        opacity='0.5'
        x='35.4521'
        y='93.5'
        width='101'
        height='12'
        fill='black'
      />
    </svg>
  )
}

export default HockeyJersey
